// extracted by mini-css-extract-plugin
module.exports = {"alertMainWrapper":"styles__alertMainWrapper___18RaM"};